module.exports = __webpack_public_path__ + "static/media/search.61b431c4.svg";